export default __webpack_public_path__ + "static/media/Maple-Bold.438a05bb.ttf";